export const getters = {
  title: (state) => state.title,
};
